import { TIME_SHORT_FORMAT } from '../../../../../common/constants/date-config';
import { DatepickerRangeModel } from '../../../../../common/models/datepicker.model';
import { findLowestNumberNotInList } from '../../../../../common';
import { AllocationCalendarSlot } from '../models';
import { addMinutes, differenceInMinutes, isAfter, isBefore, startOfDay } from 'date-fns';
import { format } from 'date-fns-tz';

export function getSlotTopPosition(
  timeFrame: DatepickerRangeModel,
  slotStart: number,
  oneMinutePxHeight: number,
): number {
  if (isBefore(new Date(slotStart), timeFrame.start)) {
    return 0;
  }

  const startPositionInMinutes: number = getRangeInMinutes(timeFrame.start, slotStart);

  return Math.ceil(oneMinutePxHeight * startPositionInMinutes);
}

export function getSlotHeight(
  timeFrame: DatepickerRangeModel,
  slotFrame: DatepickerRangeModel,
  oneMinutePxHeight: number,
): number {
  const slotEndTime: number = isBefore(new Date(slotFrame.end), timeFrame.end) ? slotFrame.end : timeFrame.end;
  const slotStartTime: number = isAfter(new Date(slotFrame.start), timeFrame.start) ? slotFrame.start : timeFrame.start;

  return Math.round(oneMinutePxHeight * getRangeInMinutes(slotStartTime, slotEndTime));
}

export function getNonWorkingHoursTopPosition(timeFrameStart: Date, start: Date, oneMinutePxHeight: number): number {
  let startPositionInMinutes: number = getRangeInMinutesFromSameDay(timeFrameStart, start);

  if (timeFrameStart.valueOf() < start.valueOf()) {
    startPositionInMinutes += timeFrameStart.getMinutes();
  }

  return Math.ceil(oneMinutePxHeight * startPositionInMinutes);
}

export function getNonWorkingHoursHeight(from: Date, to: Date, oneMinutePxHeight: number): number {
  return Math.round(oneMinutePxHeight * getRangeInMinutesFromSameDay(from, to));
}

export function getRangeInMinutes(from: number, to: number): number {
  return differenceInMinutes(new Date(to), new Date(from));
}

export function getRangeInMinutesFromSameDay(from: Date, to: Date): number {
  return differenceInMinutes(to, from);
}

export function getTimeLabelFromMinutes(minutes: number): string {
  const startTime: Date = startOfDay(new Date());
  const time: Date = addMinutes(startTime, minutes);
  return format(time, TIME_SHORT_FORMAT);
}

export function indexOf2dArray(array: [number, number, number][], target: [number, number, number]): number {
  for (const [index, value] of array.entries()) {
    if (value[0] === target[0] && value[1] === target[1] && value[2] === target[2]) {
      return index;
    }
  }
  return null;
}

export function defineSlotsColumnPositions(slots: AllocationCalendarSlot[]): void {
  slots.forEach((slot: AllocationCalendarSlot, i: number, array: AllocationCalendarSlot[]) => {
    const otherPlacedSlots = array.filter((item: AllocationCalendarSlot) => item !== slot && item.slotPosition.column);
    const neighboursColumnPositions: number[] = [];

    otherPlacedSlots.forEach((item: AllocationCalendarSlot) => {
      if (isSlotOverbooked(slot, item)) {
        slot.slotPosition.column = item.slotPosition.column + 1;

        neighboursColumnPositions.push(item.slotPosition.column);
      }
    });

    slot.slotPosition.column = findLowestNumberNotInList(1, neighboursColumnPositions);
  });
}

export function isSlotOverbooked(target: AllocationCalendarSlot, neighbor: AllocationCalendarSlot): boolean {
  if (!neighbor.slotPosition) {
    return;
  }

  const targetPositionStart = target.slotPosition.top;
  const targetPositionEnd = target.slotPosition.top + target.slotPosition.height;
  const neighborPositionStart = neighbor.slotPosition.top;
  const neighborPositionEnd = neighbor.slotPosition.top + neighbor.slotPosition.height;

  return neighborPositionStart < targetPositionStart
    ? neighborPositionEnd > targetPositionStart
    : neighborPositionStart < targetPositionEnd;
}
